import { render, staticRenderFns } from "./VendorForm.vue?vue&type=template&id=41975c88&scoped=true"
import script from "./VendorForm.vue?vue&type=script&lang=js"
export * from "./VendorForm.vue?vue&type=script&lang=js"
import style0 from "./VendorForm.vue?vue&type=style&index=0&id=41975c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41975c88",
  null
  
)

export default component.exports